const currentStatuses = {
	not_started: "NOT_STARTED",
	in_progress: "IN_PROGRESS",
	complete: "SUCCESS"
}

export default currentStatuses
